/**
 * Axios and raw fetch helpers assume paths like `/frontend/...` live under the API's `/api` prefix.
 * Normalize `VITE_API_BASE_URL` so we always resolve to `<origin>/api` (no trailing slash).
 */
export function getApiBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_API_BASE_URL ?? '').trim()
  const raw = (fromEnv || 'https://localhost:5001').replace(/\/+$/, '')
  const lower = raw.toLowerCase()
  if (lower.endsWith('/api')) return raw
  return `${raw}/api`
}
